import { render, staticRenderFns } from "./InboundItemModal.vue?vue&type=template&id=66453bc1&scoped=true&"
import script from "./InboundItemModal.vue?vue&type=script&lang=js&"
export * from "./InboundItemModal.vue?vue&type=script&lang=js&"
import style0 from "./InboundItemModal.vue?vue&type=style&index=0&id=66453bc1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66453bc1",
  null
  
)

export default component.exports